import React from 'react'
import { render } from 'react-dom'
import { createStore } from 'redux'
import { reduxApp } from './reducers/RootReducer'
import { Provider } from 'react-redux'
// import style from './styles/styles.scss'
import App from './components/App'
let store = createStore(reduxApp)

render(
  <Provider store={store}>
    <App />
  </Provider>

  , document.getElementById('app'))


// WEBPACK FOOTER //
// ./app/index.js